import { getQuery, insertQuery, updateQuery, deleteQuery } from "./UdasWrapper";
import { addErrorLog } from "../Logger/logger";

export const insertComment = async (input) => {
  try {
    const data = JSON.stringify({
      query: `mutation InsertUserComment($input: UserCommentInput) {
  insertUserComment(input: $input) {
    isSuccessful
    message
    resultObject
  }
}`,
      variables: {
        input: input,
      },
    });
    return (await insertQuery(data))?.insertUserComment;
  } catch (error) {
    addErrorLog("mutation InsertUserComment", error, input.tenant_id);
    return null;
  }
};

export const getUserCommentsByFlowId = async (tenant_id, flow_id) => {
  try {
    const data = JSON.stringify({
      query: `query GetUserCommentsByFlowId($tenantId: String, $flowId: ID) {
  getUserCommentsByFlowId(tenant_id: $tenantId, flow_id: $flowId) {
    isSuccessful
    message
    resultObject
  }
}`,
      variables: {
        tenantId: tenant_id,
        flowId: flow_id,
      },
    });
    const result = await getQuery(data);
    return result?.getUserCommentsByFlowId;
  } catch (error) {
    addErrorLog("query GetUserCommentsByFlowId", error, tenant_id);
    return null;
  }
};

export const getUserCommentsByNodeId = async (tenant_id, flow_id, node_id) => {
  try {
    const data = JSON.stringify({
      query: `query GetUserCommentsByNodeId($tenantId: String, $flowId: ID, $nodeId: String) {
  getUserCommentsByNodeId(tenant_id: $tenantId, flow_id: $flowId, node_id: $nodeId) {
    isSuccessful
    message
    resultObject
  }
}`,
      variables: {
        tenantId: tenant_id,
        flowId: flow_id,
        nodeId: node_id,
      },
    });
    const result = await getQuery(data);
    return result?.getUserCommentsByNodeId;
  } catch (error) {
    addErrorLog("query GetUserCommentsByNodeId", error, tenant_id);
    return null;
  }
};

export const deleteComment = async (tenant_id, comment_id) => {
  try {
    const data = JSON.stringify({
      query: `mutation DeleteUserCommentById($tenantId: String, $deleteUserCommentByIdId: ID) {
  deleteUserCommentById(tenant_id: $tenantId, id: $deleteUserCommentByIdId) {
    isSuccessful
    message
    resultObject
  }
}`,
      variables: {
        tenantId: tenant_id,
        deleteUserCommentByIdId: comment_id,
      },
    });
    const result = await deleteQuery(data);
    return result?.deleteUserCommentById;
  } catch (error) {
    addErrorLog("mutation DeleteUserCommentById", error, tenant_id);
    return null;
  }
};

export const updateComment = async (input) => {
  try {
    const data = JSON.stringify({
      query: `mutation UpdateUserComment($input: updateUserCommentInput) {
  updateUserComment(input: $input) {
    isSuccessful
    message
    resultObject
  }
}`,
      variables: { input: input },
    });
    return (await updateQuery(data))?.updateUserComment;
  } catch (error) {
    addErrorLog("mutation UpdateUserComment", error, input.tenant_id);
    return null;
  }
};
